// import React, { useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  CardMedia,
  Tabs,
  Tab,
  useMediaQuery,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import PetsIcon from "@mui/icons-material/Pets";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import DoneIcon from "@mui/icons-material/Done";
import { useTheme } from "@mui/material/styles";
import roomImgMain from "../../assets/hotelmain1.png";
import CalendarUI from "./CalendarUI";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const Roomdetails = () => {
  const [isShowMore, setIsShowMore] = useState(false);
  const [value, setValue] = useState(0);

  const navigate=useNavigate()
  const detailsRef = useRef(null);
  const amenitiesRef = useRef(null);
  const calendarRef = useRef(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);

    // Smooth scroll to section
    if (newValue === 0 && detailsRef.current) {
      detailsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    } else if (newValue === 1 && amenitiesRef.current) {
      amenitiesRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else if (newValue === 2 && calendarRef.current) {
      calendarRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const maxLength = 400;
  const text =
    "Genieten van een welverdiende vakantie in één van de chalets op loopafstand van het strand van Renesse. De Boormossel 5 personen is een ruim chalet van 61m2 met een ruime tuin waar u heerlijk kunt genieten in het zonnetje! De woonkamer is gezellig ingericht en beschikt over terrasdeuren. In de open keuken is divers keukeninventaris aanwezig en een vaatwasser, koelkast en combimagnetron. Het chalet beschikt over twee slaapkamers, één met een tweepersoons boxspringbed en een kamer met een stapelbed en een eenpersoonsbed. De badkamer is voorzien van een douche en wastafel. Er is een apart toilet aanwezig in het chalet.";

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, backgroundColor: "#f8f9fa" }}>
      {/* Tabs - Fixed on Top */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          left:0,
       
          mb: 3,
         
        }}
      >
        <Tabs value={value} onChange={handleChange} centered>
          <Tab label="Details" />
          <Tab label="Voorzieningen" />
          <Tab label="Beschikbaarheid" />
        </Tabs>
      </Box>

      <Grid container spacing={4}>
        {/* LEFT IMAGES */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <CardMedia
              component="img"
              src={roomImgMain}
              alt="Room Main"
              sx={{
                width: "100%",
                height: { xs: 300, md: 480 },
                objectFit: "cover",
              }}
            />
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            sx={{
              borderRadius: "16px",
              overflow: "hidden",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <CardMedia
              component="img"
              src={roomImgMain}
              alt="Room Main"
              sx={{
                width: "100%",
                height: { xs: 300, md: 480 },
                objectFit: "cover",
              }}
            />
          </Card>
        </Grid>

        {/* DETAILS SECTION */}
        <Grid item xs={12} md={8}>
          <Card
            ref={detailsRef}
            sx={{
              borderRadius: "16px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              p: { xs: 2, md: 3 },
            }}
          >
            <CardContent>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  color: "#2c3e50",
                  mb: 1,
                  fontSize: { xs: "1.5rem", md: "2rem" },
                }}
              >
                Boormossel 5 personen (hond toegestaan)
              </Typography>
              <Typography sx={{ color: "#6c757d", fontSize: "1.1rem", mb: 2 }}>
                Verblijf voor 5 personen in Renesse
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  gap: "2rem",
                  borderBottom: "1px solid #e0e0e0",
                  pb: 2,
                  mb: 2,
                }}
              >
                <Box sx={{ textAlign: "center" }}>
                  <GroupIcon sx={{ color: "#4CAF50", fontSize: 32 }} />
                  <Typography sx={{ color: "grey" }}>5 People</Typography>
                </Box>
                <Box sx={{ textAlign: "center" }}>
                  <PetsIcon sx={{ color: "#4CAF50", fontSize: 32 }} />
                  <Typography sx={{ color: "grey" }}>Pets Allowed</Typography>
                </Box>
              </Box>

              <Typography sx={{ color: "#4a4a4a", lineHeight: 1.6 }}>
                {isShowMore ? text : `${text.slice(0, maxLength)}...`}
              </Typography>
              {text.length > maxLength && (
                <Typography
                  onClick={() => setIsShowMore(!isShowMore)}
                  sx={{
                    mt: 1,
                    textDecoration: "underline",
                    color: "#007bff",
                    cursor: "pointer",
                    fontWeight: "500",
                  }}
                >
                  {isShowMore ? "Show Less" : "Show More"}
                </Typography>
              )}

              {/* AMENITIES SECTION */}
              <Box
                ref={amenitiesRef}
                sx={{
                  mt: 3,
                  pb: 2,
                  mb: 3,
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "#2c3e50", mb: 1 }}
                >
                  Voorzieningen
                </Typography>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  <DoneIcon sx={{ color: "green" }} />
                  <Typography>Honden toegestaan</Typography>
                </Box>
              </Box>

              {/* CALENDAR SECTION */}
              <Box ref={calendarRef}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#2c3e50",
                    mb: 2,
                  }}
                >
                  Beschikbaarheid
                </Typography>
                <CalendarUI />
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* BOOKING CARD */}
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              borderRadius: "16px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              maxWidth: 600,
              mx: "auto",
            }}
          >
            <Box
              sx={{
                borderBottom: "1px solid #e0e0e0",
                p: 2,
                backgroundColor: "#f1f3f4",
                borderTopLeftRadius: "16px",
                borderTopRightRadius: "16px",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Boormossel 5 personen (hond toegestaan)
              </Typography>
            </Box>

            <CardContent>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: "600" }}>
                Boek je verblijf
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.8rem",
                  mb: 2,
                  pb: 2,
                  borderBottom: "1px solid lightgrey",
                }}
              >
                <EventAvailableIcon sx={{ color: "#5A8EA1" }} />
                <Typography sx={{ color: "#555" }}>
                  2 okt. 2025 – 4 okt. 2025
                </Typography>
              </Box>

              <Typography sx={{ color: "grey", mb: 0.5 }}>Vanaf</Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "1.8rem",
                  mb: 0.5,
                  color: "#2c3e50",
                }}
              >
                € 463,08
              </Typography>
              <Typography sx={{ color: "grey", mb: 2 }}>
                incl. toeslagen
              </Typography>

              <Button
                fullWidth
                sx={{
                  backgroundColor: "#5A8EA1",
                  color: "#fff",
                  py: 1.2,
                  borderRadius: "10px",
                  textTransform: "none",
                  fontSize: "1rem",
                  "&:hover": { backgroundColor: "#4d7c8e" },
                }}
              
 onClick={()=>navigate('/bookNowFormHotel')}
              >
                Boek nu
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Roomdetails;
